export default __webpack_public_path__ + "static/media/plus.1ad834bf.svg";